import React from 'react';
import { useLanguage } from '../../../context/LanguageContext';
import '../../Pages.css';
import Billede1 from '../../../Images/Billede1.jpg';
import HeroSectionV2 from '../../../components/HeroSectionV2';
import MenuComponent from '../../../components/MenuComponent';

const Home: React.FC = () => {
    const { language } = useLanguage();
    const roles = JSON.parse(sessionStorage.getItem('userRoles') || '[]');

    return (
        <div className="home">
            <HeroSectionV2
                titleEn="Champ Ofiice Dashboard"
                titleDa="Klub"
                descriptionEn="Bla bla"
                descriptionDa="Her på siden kan du adminstration forskelige sidder"
                imageSrc={Billede1}
            />
            <section className="events-section">
                <MenuComponent itemsToShow={[23]} />
            </section>
        </div>
    );
};

export default Home;
